import React, { useState } from "react";
import config from "../../config";
import {
  TextField,
  Button,
  Typography,
  Container,
  Card,
  CardContent,
} from "@mui/material";
import axios from "axios";
import { toast } from 'react-toastify';
const url = `${config.API_BASE_URL}${config.PRODUCT_LIST_API}`;
export default function RoomTypeMaster() {
  const [roomType, setRoomType] = useState("");
  const company = JSON.parse(sessionStorage.getItem("companyDetails"));
  const saveRoomType = () => {
    if (!roomType.trim()) {
      toast.error("Please enter a Room Type");
      return;
    }

    const token = sessionStorage.getItem("token"); // Retrieve token

    axios.post(
      `${config.API_BASE_URL}/Home/SaveRoomType/${encodeURIComponent(roomType)}/${encodeURIComponent(company?.id)}`,
      null,  // no body since we're passing roomType in URL
      {
        headers: { Authorization: `Bearer ${token}` }, // Send token in headers
      }
    )
      .then(() => {
        toast.success("Room Type saved successfully!");
        setRoomType("");
      })
      .catch((err) => {
        console.error("Error saving Room Type:", err.response || err);
        toast.error(err.response?.data || "Failed to save Room Type. Check console for details.");
      });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Room Type Master
          </Typography>
          <TextField
            label="Enter Room Type"
            fullWidth
            value={roomType}
            onChange={(e) => setRoomType(e.target.value)}
            sx={{ mt: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={saveRoomType}
            sx={{ mt: 2 }}
          >
            Save Room Type
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
